import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const QR_LOGIN_FEATURE_KEY = "qrLogin";

export interface QrLoginState {
    loginRequestToken: string;
    loginRequestTokenSVG: string;
    operation: any | null;
}

export const initialQrLoginState: QrLoginState = {
    loginRequestToken: "",
    loginRequestTokenSVG: "",
    operation: null,
}

export const qrLoginSlice = createSlice({
    name: QR_LOGIN_FEATURE_KEY,
    initialState: initialQrLoginState,
    reducers: {
        setLoginRequestToken: (state: QrLoginState, action: PayloadAction<any>) => {
            state.loginRequestToken = action.payload.loginRequestToken;
            state.loginRequestTokenSVG = action.payload.loginRequestTokenSVG;
            state.operation = action.payload.operation;
        },
        setLoginOperation: (state: QrLoginState, action: PayloadAction<any>) => {
            state.operation = action.payload;
        },
    }
})

export const qrLoginReducer = qrLoginSlice.reducer;